module.exports = __webpack_public_path__ + "static/media/usdt.d3378690.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/usdt.svg
// module id = 189
// module chunks = 7